import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent, Observable } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpBackend } from "@angular/common/http";
import { environment } from "../../../environments/environment";

export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  role?: string[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
    private readonly unsubscriber: Subject<any> = new Subject();
    public readonly screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  public search: boolean = false;

  public language: boolean = false;

  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
    public megaMenuColapse: boolean = window.innerWidth < 1199;

    public collapseSidebar: boolean = window.innerWidth < 991;

    public horizontal: boolean = window.innerWidth >= 991;

    public fullScreen: boolean = false;
    private httpWithoutInterceptor: HttpClient;
  private readonly apiUrl = environment.apiRoot + "version/";

    constructor(private readonly router: Router, private readonly http: HttpClient, private httpBackend: HttpBackend) {
        this.httpWithoutInterceptor = new HttpClient(httpBackend);
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      path: "/dashboard",
      title: "Dashboards",
      icon: "assets/images/sidebar/dashboard.svg",
      type: "link",
      active: false,
      role: ["SuperAdmin", "Admin", "Operator", "QC"],
    },
    {
      path: "/client",
      title: "Clients",
      icon: "assets/images/sidebar/clients.svg",
      type: "link",
      active: false,
      role: ["SuperAdmin", "Admin", "Operator", "QC"],
    },
    {
      path: "/logger",
      title: "Logger",
      icon: "assets/images/sidebar/logger.svg",
      type: "link",
      active: false,
      role: ["SuperAdmin", "Admin"],
    },
    {
      path: "/license",
      title: "License",
      icon: "assets/images/sidebar/license.svg",
      type: "link",
      active: false,
      role: ["SuperAdmin"],
    },
    {
      path: "/feedback",
      title: "Feedback",
      icon: "assets/images/sidebar/feedback.svg",
      type: "link",
      active: false,
      role: ["SuperAdmin", "Admin"],
    },
  ];

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  getVersionold(): Observable<any> {
      const headerOptions = new HttpHeaders();
                headerOptions.append("Content-Type", "application/json");
    return this.http.get<any>(this.apiUrl+"get-version");
    
    }

    getVersion(): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpWithoutInterceptor.get<any>(`${this.apiUrl}get-version`, { headers });
    }


}
